import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { getVisitorId, getSession, captureTouch, trackEvent, lastTouch } from "@/lib/track";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fires anonymous pageviews + session/attribution events on storefront routes (skips /admin).
export default function TrafficTracker() {
  const { pathname } = useLocation();
  const last = useRef(null);
  const booted = useRef(false);

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const { id: sessionId, isNew } = getSession();
    if (!booted.current) {
      booted.current = true;
      const t = captureTouch();
      if (isNew) {
        trackEvent("session_start", { landing: t.landing });
        if (t.source || t.medium || t.campaign || t.ref) {
          trackEvent("campaign_landing", { source: t.source, medium: t.medium, campaign: t.campaign, ref: t.ref, landing: t.landing });
        }
      }
    }
    if (last.current === pathname) return;
    last.current = pathname;
    const t = lastTouch();
    axios.post(`${API}/track/pageview`, {
      path: pathname,
      referrer: document.referrer || "",
      visitor_id: getVisitorId(),
      session_id: sessionId,
      utm: { source: t.source || "", medium: t.medium || "", campaign: t.campaign || "" },
    }).catch(() => {});
  }, [pathname]);

  return null;
}
